let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lvggW")).then(() => parcelRequire('g4I8Z'));